/*--------------------------------------
           SLIDER BANNER LOGOS
 --------------------------------------*/
 SwiperInfiniteBanner = {
  init: function () {
      var swiper = new Swiper(".scrolling-logos-swiper", {
        loop: true,
        freeMode: true,
        spaceBetween: 0,
        grabCursor: false,
        allowTouchMove: false,
        slidesPerView: "auto",
        loop: true,
        autoplay: {
          delay: 1,
          disableOnInteraction: false
        },
        freeMode: true,
        speed: 5000,
        freeModeMomentum: false
      });
  }
};


$(function () {
  SwiperInfiniteBanner.init();
  
});